import React, { Component } from 'react';
import FontAwesomeIcon from 'react-fontawesome';
import { Collapse } from 'react-collapse';
import './Demo.css';

class Demo extends Component {
  constructor() {
    super();
    this.state = {
      selected: false,
      detailsDisplay: 'none',
    }
  }

  _selectDemo = () => {
    this.state.selected ? this.setState({ selected: false }): this.setState({ selected: true })
    //this.setState({ detailsDisplay: 'flex', selected: true });
  }

  render() {
    return (
        <div className="demoContainer">
          <div className="thumbnailContainer"
            onClick={this._selectDemo}>
            <div className="demoImageContainer">
              <img alt="" src={this.props.image} />
            </div>
            <h4>{this.props.title}</h4>
            <div className="tags">
              <div style={{ flexGrow: 1, textAlign: 'left' }}>St. Olaf</div>
              <div style={{ textAlign: 'right' }}>{this.props.cat}</div>
            </div>
          </div>
          <Collapse isOpened={this.state.selected}>
            <div className="triangle"></div>
            <div className="detailsContainer">
              <FontAwesomeIcon
                name="window-close"
                onClick={this._selectDemo}
                style={{textAlign: 'right', padding: '5px'}}
                />
              { typeof this.props.video !== 'undefined' &&
                <div className="videoContainer">
                  <iframe title="video" src={this.props.video} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                </div>
              }
              <div className="detailsText">
                <div>Status: {this.props.status} </div>
                <div>Contact: {this.props.contact}</div>
                <div className="documentsButton">
                  <FontAwesomeIcon
                    style={{paddingRight: '1em' }}
                    name="file" />
                  Documentation
                </div>
              </div>
            </div>
          </Collapse>
        </div>
    )
  }
}

export default Demo;



// WEBPACK FOOTER //
// ./src/components/Demo/Demo.js